/**
 * Environment Configuration
 *
 * Reads Vite's `import.meta.env`, typed by src/vite-env.d.ts, so no cast is
 * needed. The previous version cast `import.meta` to `any` and read
 * `env.NODE_ENV`, which Vite never defines: it exposes MODE, DEV and PROD. So
 * IS_DEV was always true and IS_PROD always false in every build. Nothing in
 * the application read either, which is why it went unnoticed; they are kept
 * for that reason and now report the truth.
 */

// For localhost access, always use window.location.origin to avoid CORS issues
// This ensures the frontend always uses the same port it was loaded from
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const origin = window.location.origin
    // If accessing via localhost, ALWAYS use current origin (avoids CORS and port mismatches)
    if (origin.includes('localhost') || origin.includes('127.0.0.1')) {
      return ''
    }
    // For production domains, use the configured API URL or current origin
    return import.meta.env.VITE_API_URL || ''
  }
  return import.meta.env.VITE_API_URL || ''
}

export const env = {
  API_URL: getApiUrl(),
  NODE_ENV: import.meta.env.MODE || 'development',
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const

export default env
